import React from 'react';
import Loader from './Loader';

const SingleArticleLoader = () => {
  return (
    <div className="w-100 vh-100">
      <Loader />
    </div>
  );
};

export default SingleArticleLoader;
